import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SetTotalEventsPayload = {
  totalEvents: number;
};

export type EventsState = {
  totalEvents: number;
  loadedEvents: number;
};

const initialState: EventsState = {
  totalEvents: 0,
  loadedEvents: 0,
};

const eventsSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setTotalEvents: (
      state,
      { payload }: PayloadAction<SetTotalEventsPayload>,
    ) => ({
      ...state,
      totalEvents: payload.totalEvents,
    }),
    incrementLoadedEvents: (state) => ({
      ...state,
      loadedEvents: state.loadedEvents + 1,
    }),
  },
});

export const { setTotalEvents, incrementLoadedEvents } = eventsSlice.actions;

export default eventsSlice.reducer;
